import isWellFormedDomain from '@UI/Pages/Administration/Sso/SsoFormContainer/FormData/constraint/isWellFormedDomain';

/**
 * Reads nothing beyond its own value — no cross-field logic here, unlike `isClientSecretRequired` —
 * but stays a custom constraint rather than a Joi schema because Joi has no array-of-FQDN schema in
 * this project (`guides/forms.md` §1.1). A single message covers both "empty" and "malformed": the
 * server alone distinguishes the three cases it can produce (§5.4 of the plan).
 */
function areEmailDomainsWellFormed<T>(value: readonly string[], _formData: T): boolean {
	return value.length > 0 && value.every((domain) => isWellFormedDomain(domain));
}

export default areEmailDomainsWellFormed;
